import { clientDisplayText } from "../evidencePresentation";

/** Produces a stable identity for externally generated evidence text. */
export function evidenceTextIdentity(value: string): string {
  return clientDisplayText(value)
    .normalize("NFKC")
    .replace(/\s+/g, " ")
    .trim()
    .toLocaleLowerCase();
}
